const config = {
    // BASE_URL: 'http://192.168.1.52:6979/',
    BASE_URL: 'https://h2h_backend.amerck.com/',
    // BASE_URL: 'http://192.168.4.23:3000/',
}

export default config 